export const HERO_GRAPHIC_URL = 'https://firebasestorage.googleapis.com/v0/b/insightalks-47e16.firebasestorage.app/o/herophoto.webp?alt=media&token=4ee0819b-ca44-4163-b358-469a66176505';

export const HERO_GRAPHIC_ALT = 'Professional feedback and career growth illustration';